// QueryCenter.js
import  { useEffect, useMemo, useState } from "react";
import QueryForm from "./QueryForm";
import QueryList from "./QueryList";
import QueryView from "./QueryView";
import { sharedData } from "../sharedData/sharedData";
import querySocketManager from "../socket/SocketManager";
import config from "../config/config";
import { FiX } from "react-icons/fi";
import "./QueryCenter.css";
import { userSession } from "../observers/userObserver";


const QueryCenter = ({ closeButton }) => {
  const [showForm, setShowForm] = useState(false);
  const [showList, setShowList] = useState(true);
  const [showView, setShowView] = useState(false);
  const [queryId, setQueryId] = useState(null);
  const [queryStatus, setQueryStatus] = useState("open");
  const [queries, setQueries] = useState([]);
  const [pagination, setPagination] = useState({ current_page: 1, total_items: 0, total_pages: 0, limit: 5 });
  const requestId = useMemo(() => sharedData.get("requestId"), []);

  const handlePageChange = (pageNumber) => {
    console.log("Page changed to:", pageNumber);
    setPagination((prevPagination) => ({
      ...prevPagination,
      current_page: pageNumber,
    }));
  }
  
  const token = userSession.getToken()
  const fetchQueries = async () => {
    if (!requestId) return;
    try {
      const response = await fetch(`${config["backend-url"]}/get_queries/${requestId}?page=${pagination.current_page}&limit=${pagination.limit}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      });
      if (!response.ok) throw new Error("Failed to fetch queries");
      const data = await response.json();
      setQueries(data.data.data || []);
      setPagination(data.data.pagination);
    } catch (error) {
      console.error("Error fetching queries:", error);
    }
  }

    const handleSocketConnection = () => {
        const token = userSession.getToken();
        if (!requestId || !token) return;
        querySocketManager.connect(requestId, token, null, (socket) => {
            // ✅ Safe to listen, when only connected.
            querySocketManager.on("notify_new_query", (data) => {
                console.log("New query notification:", data);
                fetchQueries();
            }, requestId);

            querySocketManager.on("notify_query_closed", (data) => {
                console.log("Query closed notification:", data);
                fetchQueries();
            }, requestId);

        });
    }

    useEffect(()=>{
        fetchQueries();
    }, [pagination.current_page]);

  useEffect(() => {
    // fetch all queries bassed on request id
    handleSocketConnection();

    return () => {
        // Cleanup socket connection when component unmounts
        if (requestId) {
            querySocketManager.off("notify_new_query", requestId);
            querySocketManager.off("notify_query_closed", requestId);
            // querySocketManager.leaveRoom(requestId);
            querySocketManager.disconnect(requestId);
        }
    }

  }, []);  

  return (
    <div className="query-center">
      <button className="query-modal-close-btn"
        onClick={() => {
          closeButton();
        }}
      >
        <FiX size={24} />
  </button>
      <h2>Request {requestId} - Communications Centre </h2>
      {!showView && (
        <button onClick={() => {setShowForm(!showForm); setShowList(!showList);}} style={{ marginBottom: "10px", padding: "10px", backgroundColor: "#059a99", color: "white", border: "none", borderRadius: "4px", cursor: "pointer" }}>
          {showForm ? "Cancel" : "Create New"}
        </button>
      )}
      { showForm && <QueryForm onSubmit={() => {setShowForm(false); setShowList(true);}} /> }
      { showList && <QueryList queries={queries} onView={(id, status) => {
            setQueryId(id); // 👈 Set the queryId
            setQueryStatus(status);
            setShowForm(false);
            setShowList(false);
            setShowView(true);
          }} 
          pagination={pagination}
          onPageChange={handlePageChange}
          />}
          {/* {
            showList && <>
              <DynamicTable data={queries} columns={columns} />
              <Pagination totalPages={pagination.total_pages} page={pagination.current_page} handlePageChange={handlePageChange}/>
            </>
          } */}
      { showView && <QueryView queryId={queryId} queryStatus={queryStatus}
          onBack={() => {
            setShowView(false);
            setShowList(true);
            setShowForm(false);
          }} />}
    </div>
  );
};

export default QueryCenter;
